import axios from './axiosConfig'
import { getEnv } from '@utils/env'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

export interface ICallFilteringSettings {
  clinic_call_filtering_settings_id?: string
  clinic_id: string
  block_unknown_callers: boolean
  block_international_calls: boolean
  updated_by?: string | null
  date_time_created_at?: string
  date_time_updated_at?: string
}

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchCallFilteringSettingsApi = async (
  clinicId: string,
): Promise<
  ApiEnvelope<{ call_filtering_settings: ICallFilteringSettings }>
> => {
  const response = await axios.get<
    ApiEnvelope<{ call_filtering_settings: ICallFilteringSettings }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/call-filtering-settings/${clinicId}`)
  return response.data
}

export const saveCallFilteringSettingsApi = async (
  payload: Pick<
    ICallFilteringSettings,
    | 'clinic_id'
    | 'block_unknown_callers'
    | 'block_international_calls'
    | 'updated_by'
  >,
): Promise<
  ApiEnvelope<{ call_filtering_settings: ICallFilteringSettings }>
> => {
  const response = await axios.put<
    ApiEnvelope<{ call_filtering_settings: ICallFilteringSettings }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/call-filtering-settings`, payload)
  return response.data
}
